import { MinorServiceClassification } from './minor-service-classification';

export class MajorServiceClassification {
  majorServiceClassificationId: number;
  name: string;
  classificationNumber: number;
  selected?: boolean;
  minorServiceClassifications?: MinorServiceClassification[];
}
